import axios from 'axios'

export default {
  namespaced: true,
  state: {
    allDrivers: undefined,
    firstFetchDone: false,
  },
  mutations: {
    SET_DRIVERS(state, drivers) {
      state.allDrivers = drivers
    },
    UPDATE_DRIVER(state, newData) {
      state.allDrivers = state.allDrivers.map((driver) => {
        if (newData.id !== driver.id) {
          return driver
        }
        return newData
      })
    },
    SET_FIRST_FETCH_DONE_TRUE(state) {
      state.firstFetchDone = true
    },
  },
  actions: {
    GET_DRIVERS({ commit, rootState }) {
      axios.get(`${rootState.api}/drivers`).then((res) => {
        const drivers = res && res.data && res.data.data
        if (Array.isArray(drivers)) {
          commit('SET_DRIVERS', drivers)
        }
      })
        .finally(() => commit('SET_FIRST_FETCH_DONE_TRUE'))
    },
    ADD_DRIVER({ rootState, dispatch }, driverData) {
      if (driverData.id) {
        return axios
          .get(`${rootState.api}/drivers/${driverData.id}`)
          .then((res) => {
            dispatch(
              'quotation/ADD_DRIVER_TO_QUOTATION',
              res.data.data,
              {
                root: true,
              },
            )
          })
      }
      axios.post(`${rootState.api}/drivers`, driverData).then((res) => {
        dispatch('quotation/ADD_DRIVER_TO_QUOTATION', res.data.data, {
          root: true,
        })
        return dispatch('GET_DRIVERS')
      })
    },
    EDIT_DRIVER({ commit, rootState, dispatch }, driverData) {
      if (driverData.id) {
        return axios
          .put(`${rootState.api}/drivers/${driverData.id}`, driverData)
          .then((res) => {
            commit(
              'UPDATE_DRIVER',
              res.data.data,
            )
            dispatch('GET_DRIVERS')
          })
      }
    },
  },
  getters: {
    optionalDrivers(state) {
      return (
        state.allDrivers
                && state.allDrivers.filter((driver) => !driver.is_main)
      )
    },
  },
}
